var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isResumingLearningPath || _vm.isResumingCourse)?_c('div',[(_vm.isResumingLearningPath)?_c('ResumeFromLearningPath',_vm._b({on:{"resume-content":_vm.handleResume}},'ResumeFromLearningPath',{
        learningPath: _vm.learningPath,
        course: _vm.course,
        learningArea: _vm.learningArea,
        instructor: _vm.instructor,
        courseLinkProperties: _vm.courseLinkProperties,
        hasNextUpContent: _vm.hasNextUpContent,
        nextUpProperties: _vm.nextUpProperties,
        isLoading: _vm.isLoading,
      },false)):_c('ResumeFromCourse',_vm._b({on:{"resume-content":_vm.handleResume}},'ResumeFromCourse',{
        course: _vm.course,
        learningArea: _vm.learningArea,
        instructor: _vm.instructor,
        courseLinkProperties: _vm.courseLinkProperties,
        hasNextUpContent: _vm.hasNextUpContent,
        nextUpProperties: _vm.nextUpProperties,
        isLoading: _vm.isLoading,
      },false))],1):_c('div',[_c('div',{style:(("background-image: url(" + (_vm.$getPlaylistBackground(
          _vm.fallbackLearningPath.id
        )) + "), linear-gradient(#151515, #262626); background-size: cover;"))},[_c('Fallback'),_c('FallbackCourseListing')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }